import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import PrivacyPolicy from '../components/PrivacyPolicy';

const PrivacyPolicyRoute = () => {

  return (
    <>
      <Helmet>
        <title>AskPics — Privacy</title>
        <meta name="description" content="Read the AskPics Privacy Policy to learn how we handle your data and protect your privacy." />
        <link rel="canonical" href="https://askpics.app/privacy" />
      </Helmet>
      <div>
        <main>
          <PrivacyPolicy />
        </main>
      </div>
    </>
  );
};

export default PrivacyPolicyRoute;
